import { JetView } from 'webix-jet'; // Importing JetView from webix-jet for creating views
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import { devConfig } from 'config/config'; // Importing development configuration
import { profile } from 'config/config'; // Importing profile configuration

/**
 * Class representing the leagues list view.
 * @extends JetView
 */
export default class tableLeaguesListView extends JetView {
    /**
     * Configures the view.
     * @returns {Object} Configuration object for the datatable.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        var vthis = this; // Reference to the current instance

        /**
         * Custom checkbox rendering function.
         * @param {Object} obj - The data object for the row.
         * @param {Object} common - Common properties for the checkbox.
         * @param {string} value - The value of the checkbox.
         * @returns {string} HTML string for the custom checkbox.
         */
        function custom_checkbox(obj, common, value) {
            if (value != 'N')
                return ''; // Return empty if value is not 'N'
            else
                return '<div style=" padding: 0px 14px;display: inline-block;background: green;color: #fff;font-size: 13px; " class=\'webix_table_checkbox webixbutton approbarbutton\'>A</div><div style=" padding: 0px 14px;display: inline-block;background: red;color: #fff;font-size: 13px;" class=\'webix_table_checkbox webixbutton rechazarbutton\'> N </div>'; // Return custom HTML for checkboxes
        }

        return {
            view: 'datatable', // Define the view as a datatable
            css: 'webix_header_border webix_data_border', // CSS classes for styling
            scrollY: screen.width < 820 ? false : true, // Enable vertical scrolling based on screen width
            height: screen.width < 820 ? 405 : 0, // Set height based on screen width
            select: true, // Enable row selection
            columns: [
                // Define columns for the datatable
                {
                    id: 'detailTittle',
                    header: '',
                    width: 50,
                    height: 25,
                    tooltip: _('Detalles'), // Tooltip for the column
                    template: function (obj) {
                        return "<span class='webix_icon wxi-close details'></span>"; // Template for detail icon
                    },
                },
                {
                    id: 'rating',
                    header: '',
                    width: 50,
                    height: 25,
                    tooltip: _('Resultados'), // Tooltip for the column
                    template: function (obj) {
                        return "<span class='webix_icon wxi-close reply'></span>"; // Template for rating icon
                    },
                },
                { id: 'id', header: 'ID', width: 100, sort: 'int' }, // Column for ID
                { id: 'Name', header: _('Nombre'), width: 200, sort: 'int' }, // Column for Name
                {
                    id: 'Description',
                    header: _('Descripción'), // Column for Description
                    width: 220,
                    sort: 'int',
                },
                {
                    id: 'TypeProduct',
                    header: _('Tipo de Producto'), // Column for Product Type
                    width: 220,
                    sort: 'int',
                },
                {
                    id: 'IsActivate',
                    header: _('Estado'), // Column for Status
                    options: [
                        // Options for the status dropdown
                        { id: '', value: _('None') },
                        { id: 'A', value: _('Activado') },
                        { id: 'C', value: _('Cancelado') },
                        { id: 'I', value: _('Inactivado') },
                    ],
                },
                {
                    id: 'DateStart',
                    header: _('Fecha Inicio'), // Column for Start Date
                    fillspace: 0,
                    minWidth: 0,
                    width: 200,
                    sort: 'text',
                    format: dateFormat, // Date format for the column
                },
                {
                    id: 'DateEnd',
                    header: _('Fecha Fin'), // Column for End Date
                    fillspace: 0,
                    minWidth: 0,
                    width: 200,
                    sort: 'text',
                    format: dateFormat, // Date format for the column
                },
                {
                    id: 'Partner',
                    header: _('Partner'), // Column for Partner
                    width: 150,
                    sort: 'int',
                    options: profile.Partners, // Options for the Partner dropdown
                },
            ],
            editable: true, // Enable editing of the datatable
            tooltip: true, // Enable tooltips
            math: true, // Enable mathematical operations
            loadahead: devConfig.getDefaultDataFetch(), // Load ahead configuration
            pager: 'pagerA', // Pager configuration
            url: devConfig.geturlApi() + 'Leagues/GetLeagues', // API URL for fetching data
            data: [
                // Initial data for the datatable
                {
                    id: '01',
                    Name: 'Liga 1',
                    Description: 'descripcion de la liga 1',
                    TypeProduct: '01',
                    IsActivate: 'A',
                    DateStart: '2017-03-06 11:32:20',
                    DateEnd: '2017-03-06 11:32:20',
                    Partner: '0',
                },
            ],
            on: {
                // Event handlers for the datatable
                onItemDblClick: (id) => {
                    // Double click event
                    this.show(
                        'leagues.leaguesManagement?league=' + id + '/leagues.information', // Show league management view
                    );
                },
            },
            onClick: {
                // Click event handlers
                details: function (euv, id) {
                    // Details button click
                    vthis.show(
                        'leagues.leaguesManagement?league=' + id + '/leagues.information', // Show league management view
                    );
                },
                reply: function (euv, id) {
                    // Reply button click
                    var item = this.getItem(id); // Get the clicked item
                    vthis.app.callEvent('resultsTable:id', [item]); // Trigger event with item data
                },
                approbarbutton: function (ev, id) {
                    // Approve button click
                    var item = this.getItem(id); // Get the clicked item
                    if (item.StateValidate == 'N') {
                        // Check if the state is 'N'
                        const data = {
                            Id: item.Id,
                            Action: 'A', // Action to approve
                        };
                        webix
                            .ajax() // AJAX request to approve
                            .headers({
                                'Content-type': 'application/json', // Set content type
                            })
                            .post(
                                devConfig.geturlApi() + 'Agent/SetStateValidate', // API URL for state validation
                                data,
                                {
                                    error: function (text, data, XmlHttpRequest) {
                                        webix.message(_('Error')); // Show error message
                                    },
                                    success: function (text, data, XmlHttpRequest) {
                                        var json = JSON.parse(text); // Parse response
                                        if (json.HasError) {
                                            // Check for errors
                                            webix.message({
                                                title: _('¡Error!'),
                                                type: 'alert-error',
                                                text: _(
                                                    'Ocurrio un error, comuniquese con soporte', // Show error message
                                                ),
                                            });
                                        } else {
                                            item.StateValidate = 'A'; // Update state to 'A'
                                            item.Action = 'A'; // Update action to 'A'
                                            webix.message(_('Guardado')); // Show success message
                                        }
                                    },
                                },
                            );
                    } else {
                        webix.message({
                            title: _('¡Error!'),
                            type: 'alert-error',
                            text: _(
                                'No puedes activar un registro ya actualizado.', // Show error message
                            ),
                        });
                    }
                },
                rechazarbutton: function (ev, id) {
                    // Reject button click
                    var item = this.getItem(id); // Get the clicked item
                    if (item.StateValidate == 'N') {
                        // Check if the state is 'N'
                        const data = {
                            Id: item.Id,
                            Action: 'I', // Action to reject
                        };
                        webix
                            .ajax() // AJAX request to reject
                            .headers({
                                'Content-type': 'application/json', // Set content type
                            })
                            .post(
                                devConfig.geturlApi() + 'Agent/SetStateValidate', // API URL for state validation
                                data,
                                {
                                    error: function (text, data, XmlHttpRequest) {
                                        webix.message('Error'); // Show error message
                                    },
                                    success: function (text, data, XmlHttpRequest) {
                                        var json = JSON.parse(text); // Parse response
                                        if (json.HasError) {
                                            // Check for errors
                                            webix.message({
                                                title: _('¡Error!'),
                                                type: 'alert-error',
                                                text: _(
                                                    'Ocurrio un error, comuniquese con soporte', // Show error message
                                                ),
                                            });
                                        } else {
                                            item.StateValidate = 'I'; // Update state to 'I'
                                            item.Action = 'I'; // Update action to 'I'
                                            webix.message(_('Guardado')); // Show success message
                                        }
                                    },
                                },
                            );
                    } else {
                        webix.message({
                            title: _('¡Error!'),
                            type: 'alert-error',
                            text: _(
                                'No puedes activar un registro ya actualizado.', // Show error message
                            ),
                        });
                    }
                },
            },
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The datatable instance.
     */
    init(grid) {
        var url = grid.data.url; // Get the URL for data loading
        this.on(this.app, 'agentList:filter', (filterData) => {
            // Event listener for filtering
            var object = Object.entries(filterData); // Convert filter data to entries
            console.log('obj ', filterData); // Log filter data
            var string1 = ''; // Initialize query string
            for (var i = 0; i < object.length; i++) {
                // Iterate through filter data
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    // Check if value is not an object and not empty
                    if (object[i][0] == 'DateStart') {
                        // Check for DateStart filter
                        var date = object[i][1].split(' - '); // Split date range
                        console.log(date); // Log date range
                        string1 = string1 + '&dateFrom=' + date[0]; // Add start date to query string
                        string1 = string1 + '&dateTo=' + date[1]; // Add end date to query string
                    } else {
                        if (object[i][0] == 'DateEnd') {
                            // Check for DateEnd filter
                            var date = object[i][1].split(' - '); // Split date range
                            console.log(date); // Log date range
                            string1 = string1 + '&dateFrom2=' + date[0]; // Add start date to query string
                            string1 = string1 + '&dateTo2=' + date[1]; // Add end date to query string
                        } else {
                            string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Add other filters to query string
                        }
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        // Check if value is an object
                        var object2 = Object.entries(object[i][1]); // Convert object to entries
                        for (var j = 0; j < object2.length; j++) {
                            // Iterate through object entries
                            if (object2[j][1] !== null) {
                                // Check if value is not null
                                if (object2[j][0] === 'start') {
                                    // Check for start date
                                    if (object[i][0] === 'DateStart') {
                                        // Check if filtering DateStart
                                        var d = new Date(object2[j][1]); // Create date object
                                        console.log('rere ' + d); // Log date
                                        var dateFrom =
                                            'dateFrom=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2); // Format date for query string
                                        string1 = string1 + '&' + dateFrom; // Add formatted date to query string
                                    }
                                    if (object[i][0] === 'DateEnd') {
                                        // Check if filtering DateEnd
                                        var d = new Date(object2[j][1]); // Create date object
                                        var dateFrom =
                                            'dateFrom2=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2); // Format date for query string
                                        string1 = string1 + '&' + dateFrom; // Add formatted date to query string
                                    }
                                } else {
                                    if (object2[j][0] === 'end') {
                                        // Check for end date
                                        if (object[i][0] === 'DateStart') {
                                            // Check if filtering DateStart
                                            var d = new Date(object2[j][1]); // Create date object
                                            var dateFrom =
                                                'dateTo=' +
                                                d.getFullYear() +
                                                ':' +
                                                ('00' + (d.getMonth() + 1)).slice(-2) +
                                                ':' +
                                                ('00' + d.getDate()).slice(-2) +
                                                ' ' +
                                                ('00' + d.getHours()).slice(-2) +
                                                ':' +
                                                ('00' + d.getMinutes()).slice(-2) +
                                                ':' +
                                                ('00' + d.getSeconds()).slice(-2); // Format date for query string
                                            string1 = string1 + '&' + dateFrom; // Add formatted date to query string
                                        }
                                        if (object[i][0] === 'DateEnd') {
                                            // Check if filtering DateEnd
                                            var d = new Date(object2[j][1]); // Create date object
                                            var dateFrom =
                                                'dateTo2=' +
                                                d.getFullYear() +
                                                ':' +
                                                ('00' + (d.getMonth() + 1)).slice(-2) +
                                                ':' +
                                                ('00' + d.getDate()).slice(-2) +
                                                ' ' +
                                                ('00' + d.getHours()).slice(-2) +
                                                ':' +
                                                ('00' + d.getMinutes()).slice(-2) +
                                                ':' +
                                                ('00' + d.getSeconds()).slice(-2); // Format date for query string
                                            string1 = string1 + '&' + dateFrom; // Add formatted date to query string
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
            grid.clearAll(); // Clear existing data in the grid
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1); // Load new data with filters
        });
        grid.attachEvent('onItemClick', function (id, e, node) {
            // Item click event
            var item = this.getItem(id); // Get the clicked item
            this.$scope.app.callEvent('user:id', [item.Id]); // Trigger event with item ID
        });
        grid.attachEvent('onBeforeEditStart', function (id) {
            // Before edit start event
            var item = this.getItem(id); // Get the item being edited
            console.log(item); // Log item data
            if (id.column == 'Action') {
                // Check if editing the Action column
                var options = this.getColumnConfig('Action').collection; // Get options for Action column
                if (item.StateValidate != 'N') {
                    // Check if state is not 'N'
                    console.log(item); // Log item data
                    return false; // Prevent editing
                }
                console.log(id); // Log column ID
            }
        });
        this.on(this.app, 'player:select', (Id) => {
            // Event listener for player selection
            grid.load(
                grid.data.url + '?start=0&count=' + grid.data.$pagesize + '&PlayerId=' + Id, // Load data filtered by PlayerId
            );
        });
    }
}

// FILE DOCUMENTED
